import {
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
} from "@material-ui/core";

export default function CommonDialog2Choices(props) {
  const { onClose, title, message } = props;

  return (
    <Dialog open onClose={() => onClose('close')}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => onClose('cancel')} autoFocus>
          いいえ
        </Button>
        <Button color="primary" onClick={() => onClose('ok')}>
          はい
        </Button>
      </DialogActions>
    </Dialog>
  );
}
